import { render, staticRenderFns } from "./materialintegralruledetail.vue?vue&type=template&id=38826fff&"
import script from "./materialintegralruledetail.vue?vue&type=script&lang=js&"
export * from "./materialintegralruledetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports